/**
 * 文件说明:
 *
 * global layout
 *
 * ----------------------------------------
 * 创建用户: leo
 */

import {memo} from 'react'
import {Layout} from 'antd'
import {useInit} from 'hooks'
import PageLoading from 'components/page-loading'
import HzGlobalHeader from '../header'
import styles from './index.less'

const GlobalLayout = memo((props) => {
    const {PageComponent, pageProps, children, authLayoutData = {}} = props

    const {
        globalPage = false,
        globalPageLayout = false,
        noInit = false,
        useGlobalHeader = true,
    } = authLayoutData?.hzLayoutOption ?? {}

    const {status} = useInit({noInit, pathname: pageProps?.location?.pathname})

    if (globalPage) {
        return <PageComponent {...pageProps} hzAuthStatus={status} />
    }

    if (status === 1) {
        if (globalPageLayout) {
            return <PageComponent {...pageProps} />
        }

        const {GlobalHeader = HzGlobalHeader} = PageComponent?.hzLayoutOption ?? {}

        return (
            <PageComponent {...pageProps}>
                <Layout className={styles.main}>
                    {useGlobalHeader ? <GlobalHeader>{children}</GlobalHeader> : {children}}
                </Layout>
            </PageComponent>
        )
    }

    if (status === 0 || status === 3 || status === 4) {
        return <PageLoading tip="初始化中..." />
    }

    throw new Error('初始化失败')
})

export default GlobalLayout
